<button
    [type]="type()"
    class="inline-flex w-full items-center justify-center rounded-sm"
    [class]="classes()"
    [class.opacity-60]="disabled()"
    [class.!cursor-default]="disabled()">
    <div
        class="font-open-sans flex items-center text-center"
        [class]="slotClasses()"
        [class.font-bold]="bold()"
        [class.underline]="underline()">
        <ng-content></ng-content>
    </div>
</button>
